import { render, staticRenderFns } from "./TextTruncatorCss.vue?vue&type=template&id=415a469a&"
import script from "./TextTruncatorCss.vue?vue&type=script&lang=js&"
export * from "./TextTruncatorCss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports